
export class KhachHangEinvoice {
    TenDonVi: string;
    TenKhachHang: string;
  MST: string;
  SDT: string;
  DiaChi: string;
  Website: string;
  Email: string;
  MaNVTao: string;
  }

export class EinvoiceReceive {
  ViewURL: string;
  VAT: string;
}



// WEBPACK FOOTER //
// ./src/app/models/einvoice.model.ts